export default __webpack_public_path__ + "static/tatiana-e8f7cd4366342e9b1a9d788cf5106157.png";